import { createMuiTheme } from "@material-ui/core";

let theme = createMuiTheme({
	palette: {
		primary: {
			light: "#fc9830",
			main: "#ff8201",
			dark: "#e57400",
			contrastText: "rgba(255, 255, 255, 1)",
		},
		secondary: {
			light: "#a4a4a4",
			main: "#2b2b2b",
			dark: "#171717",
			contrastText: "rgba(255, 255, 255, 1)",
		},
	},
	overrides: {},
});

theme.overrides = {
	MuiTypography: {
		headline: {
			fontSize: "2.625rem",
			fontWeight: 600,
			lineHeight: "1.1em",
			color: theme.palette.secondary.main,
			[theme.breakpoints.down("md")]: {
				fontSize: "1.75rem",
			},
			[theme.breakpoints.down("sm")]: {
				fontSize: "1.25rem",
			},
		},
		title: {
			fontSize: "1.75rem",
			fontWeight: 300,
			color: theme.palette.secondary.light,
			[theme.breakpoints.down("md")]: {
				fontSize: "1.25rem",
			},
			[theme.breakpoints.down("sm")]: {
				fontSize: "1rem",
			},
		},
		body1: {
			fontSize: "1rem",
			[theme.breakpoints.down("sm")]: {
				fontSize: "0.875rem",
			},
		},
	},
	MuiExpansionPanelSummary: {
		root: {
			padding: "0 15px",
			minHeight: "52px !important",
			backgroundColor: "#DFDFDF !important",
		},
		content: {
			margin: "12px !important",
		},
		expandIcon: {
			top: "48%",
			right: 10,
			color: "#2B2B2B",
		},
	},
	MuiExpansionPanelDetails: {
		root: {
			flexWrap: "wrap",
		},
	},
	MuiPaper: {
		root: {
			width: "100%",
			backgroundColor: "transparent",
		},
		elevation1: {
			boxShadow: "none",
		},
	},
	MuiInput: {
		input: {
			padding: "7px 0",
		},
	},
	MuiButton: {
		root: {
			fontSize: "1.125rem",
			lineHeight: "1.38em",
			textTransform: "none",
			padding: "10px 25px",
			border: "1px solid transparent",
			borderRadius: "25px",
			[theme.breakpoints.down("sm")]: {
				fontSize: "1rem",
			},
			[theme.breakpoints.down("xs")]: {
				fontSize: "0.875rem",
			},
		},
		raisedPrimary: {
			color: theme.palette.primary.main,
			backgroundColor: "white",
			border: "2px solid",
			transition: "0.1s",
			boxShadow: "none",
			borderColor: theme.palette.primary.main,
			"&:hover": {
				color: "white",
				backgroundColor: theme.palette.primary.main,
			},
		},
		raisedSecondary: {
			boxShadow: "none",
			"&:hover": {
				color: "white",
				backgroundColor: theme.palette.primary.main,
			},
		},
		mini: {
			boxShadow: "none",
			backgroundColor: "transparent",
			"&:hover, &:focus": {
				boxShadow: "none",
				backgroundColor: "transparent",
			},
		},
	},
	MuiFormControl: {
		marginNormal: {
			[theme.breakpoints.down("xs")]: {
				marginTop: "8px",
			},
		},
	},
	MuiSelect: {
		select: {
			"&:focus": {
				backgroundColor: "transparent",
			},
		},
	},
	MuiChip: {
		root: {
			color: "#a4a4a4",
			border: "1px solid #a4a4a4",
			backgroundColor: "transparent",
		},
		deletable: {
			"&:hover, &:focus": {
				backgroundColor: "transparent",
			},
		},
	},
	MuiCardMedia: {
		root: {
			height: 185,
		},
	},
	MuiListItemIcon: {
		root: {
			marginRight: 0,
		},
	},
};

export default theme;



// WEBPACK FOOTER //
// ./src/stylesheets/theme.js